module.exports = __webpack_public_path__ + "static/media/logo_with_hint.ed692dcf.png";